import {Modal} from 'asteq.modal';
import {DetailModalSlider} from 'asteq.sliders.detailmodalslider';

export class Zoom {
    constructor(params = {}) {
        this.modal = null;
        this.zoomSlider = null;
        this.parent = params.parentSlider;

        this.init(params);
    }

    init(params) {
        const modalEl = document.querySelector('#' + params.modalId);
        if (modalEl) {
            this.modal = new Modal({
                element: modalEl,
            });
        }

        if (this.modal?.el) {
            const zoomSliderEl = this.modal.el.hasAttribute('data-main-swiper')
                ? this.modal.el
                : this.modal.el.querySelector('#' + params.zoomSliderId);
            if (zoomSliderEl) {
                this.zoomSlider = new DetailModalSlider(zoomSliderEl, {});
                this.parent
            }
        }
    }

    initParentSlidesEvents() {
        if (!this.parent?.mainSwiper?.slides) {
            return;
        }

        this.parent.mainSwiper.slides.forEach((slide) =>
            slide.addEventListener('click', this.onOpenBySlide.bind(this)));
    }

    onOpenBySlide(e) {
        this.zoomSlider.setImages({
            thumbs: this.parent.imagesSets.thumbs,
            slides: this.parent.imagesSets.details,
        });
        const currentIndex = this.parent.mainSwiper.activeIndex;
        if(currentIndex != null) {
            this.zoomSlider.mainSwiper.slideTo(currentIndex, 0);
        }

        this.modal.open();
    }

    onAfterSetImagesParent(e) {
        this.initParentSlidesEvents();
    }
}